<div class="conatiner-wrapper">
  <div class="header" *ngIf="!showHideSearch">
    <div class="image-logo">
      <a href="./">
        <img class="logo" alt="5paisa Logo" title="5paisa Logo" src="https://images.5paisa.com/Campaign/5paisa-logo.svg">
      </a>
    </div>

    <h1>{{subCategoryName}}</h1>
    <div class="header-image-wrapper">
      <img (click)="changeHeader()" alt="Search Icon" title="Search Icon" src="https://images.5paisa.com/forum/icon-search.png" />
      <!-- <img src="https://images.5paisa.com/forum/icon-language.png" /> -->
    </div>

  </div>
  <div class="header-search-bar" *ngIf="showHideSearch">
    <div class="form-tab">
      <!-- <img (click)="goBack()" src="https://images.5paisa.com/forum/icon-left-arrow.svg" /> -->
      <div class="search-field d-flex position-relative w-100">
        <span class="icon-search"></span>
        <form [formGroup]="searchForm" novalidate>
          <input autocomplete="off" type="text" pattern="^[a-zA-Z0-9?]*$" name="input" id="input" class="text-field"
            placeholder="Eg: how do i activate F&O ?" formControlName="searchText" (keyup)="searchByString()" (keypress)="omit_special_char($event)"/>
          <ul class="results" *ngIf="showResults">
            <li *ngFor="let item of searchListArray">
              <a *ngIf="item.title != ''" (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink)">{{item.title}}</a>
              <a *ngIf="item == 'No results found'">{{item}}</a>
            </li>
          </ul>
        </form>
      </div>
      <span class="icon-cross" (click)="closeSearchBar()"></span>
    </div>
  </div>



  <div class="faq-details-section" *ngIf="!showLoader">
    <h2>
      {{answer.title}}
    </h2>

    <p [innerHtml]="summeryAnswer"></p>
    <hr>

    <p class="text-left">Updated: {{convertedDate}}</p>
    <hr>
    <div class="like-dislike-wrapper">
      <span>Was this article helpful?</span>
      <div class="icon-wrapper">
        <div class="like" (click)="likeArticle(answer.id)">
          <span [ngClass]="likeTrue == true ? 'icon-liked' : 'icon-like'"></span>
          <span [ngClass]="likeTrue == true ? 'text-liked' : 'text-like'">Like</span>
        </div>

        <div class="dislike" (click)="disLikeArticle(answer.id)">
          <span [ngClass]="disLikeTrue == true ? 'icon-disliked' : 'icon-dislike'"></span>
          <span [ngClass]="disLikeTrue == true ? 'text-liked' : 'text-dislike'">Dislike</span>
        </div>
      </div>
    </div>

    <div class="create-ticket-wrapper">
      <h3 class="main-heading">Still Stuck?</h3>
      <h5 class="sub-heading">Have you tried looking for an answer?</h5>
      <p>
        Create a ticket and we will respond as soon as possible, or you can
        return later.
      </p>
      <div class="row-wrapper">
        <div class="ticket-button-wrapper">
          <button class="primary-btn" (click)="goToCreateTicket()">Create a Ticket</button>
          <!-- <button class="transparent-btn">Or contact our support</button> -->
          <button class="transparent-btn" (click)="letsChat()">or Chat with us</button>
        </div>
        <div class="phone-icon-container">
          <a href="tel:8976689766" class="phone-icon">
            <img class="" src="https://images.5paisa.com/forum/Call.png" alt="Phone Icon"/>
          </a>
        </div>
      </div>
    </div>

  </div>

  <app-loader *ngIf="showLoader"></app-loader>

</div>